import BaseClass from "./BaseClass";

const defaultOptions = {};

export default class Like extends BaseClass {

    constructor(options) {
        super(options, defaultOptions);

        this.init();
    }

    init() {}

    /**
     * Store like value logging - either hotel or review
     *
     * @param {Element} e clicked element
     */
    storeLikeIDBeforeLogin(e) {
        let id = $(e).data('id');
        $("input[name='"+$(e).data('sessionName')+"']").val(id);
        $("#loginModal").modal('show');
    }

    /**
     * Function that deletes like session
     */
    deleteLikeFromID() {
        $("input[name='fav_hotel']").val("");
        $("input[name='like_review']").val("");
    }
}
